/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostAnomalyResourcesRequest {
    getFixupPrototypeFunction() { return CostAnomalyResourcesRequest.fixupPrototype; }

    static newInstance(model: Partial<CostAnomalyResourcesRequest>): CostAnomalyResourcesRequest {
        let obj = Object.assign(new CostAnomalyResourcesRequest(), model);
        CostAnomalyResourcesRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostAnomalyResourcesRequest>): CostAnomalyResourcesRequest {
        if (!model) return null;
        return CostAnomalyResourcesRequest.newInstance(<CostAnomalyResourcesRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostAnomalyResourcesRequest) {
        if (!obj) return;

        models.CostAnomalyResourcesRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostAnomalyResourcesRequest): boolean {
        Object.setPrototypeOf(obj, CostAnomalyResourcesRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.start_date === "string") {
            this.start_date = new Date(<string><any>this.start_date);
        }
        if (typeof this.end_date === "string") {
            this.end_date = new Date(<string><any>this.end_date);
        }
        if (this.filters) {
            models.QueryOperator.fixupPrototype(this.filters);
        }
    }

    /**
     * Service Account IDs
     */
    service_account_ids: Array<string>;

    /**
     * Query expression to filter line items
     */
    filters: models.QueryOperator;

    /**
     * specify the start date
     */
    start_date: Date;

    /**
     * specify the end date
     */
    end_date: Date;

    /**
     * Optional timezone of the caller
     */
    time_zone: string;

    /**
     * Records based on the actual metric that is used during anomaly detection
     */
    billing_source: string;

}
